import React from 'react';
import { SidePanelContentCard } from '@brighterionai/br-ui';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'Components/Breadcrumbs/routes';
import { useAppStore } from 'Store';
import { getInvalidateQueries } from '@brighterion/utils/general';
import { useGetListDetailsFromLocation } from 'Hooks/useGetListDetailsFromLocation';
import { useQueryClient } from '@tanstack/react-query';
import useGetSidePanelContentCardHelperData from '../../../../hooks/useGetSidePanelContentCardHelperData';
import SidePanelContentCardHelper from './SidePanelContentCardHelper';

type SidePanelAccordionItemContentCardProps = {
    id: number;
    itemData: SidePanelAccordionItemContentCardData;
    expandedCardIndex: number;
    handleCardHeaderOnClick: (cardIndex: number, isExpanded: boolean) => void;
};

const SidePanelAccordionItemContentCard = ({
    id,
    itemData,
    expandedCardIndex,
    handleCardHeaderOnClick
}: SidePanelAccordionItemContentCardProps) => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const { list, subList } = useGetListDetailsFromLocation();
    const { toggleSidePanel, setCurrentListId, setEntityPendingChanges } = useAppStore();
    const { getHelperData, isHelperDataAvailable } = useGetSidePanelContentCardHelperData(itemData);
    const cardHelperData = React.useMemo(() => {
        return getHelperData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemData]);

    const onActionCallback = () => {
        const listName = itemData?.entryName;
        const baseRoutes: Record<string, any> = {
            'Allowed Entities': ROUTES.LISTS.ALLOWED_ENTITIES,
            'Denied Entities': ROUTES.LISTS.DENIED_ENTITIES,
            'Allowed Countries': ROUTES.LISTS.ALLOWED_COUNTRIES,
            'Denied Countries': ROUTES.LISTS.DENIED_COUNTRIES,
            'Address Noise Words': ROUTES.LISTS.ADDRESS_NOISEWORDS,
            'Noise Words': ROUTES.LISTS.NAME_NOISEWORDS
        };
        const clickedBaseRoute = baseRoutes[listName] || '';
        if (clickedBaseRoute && itemData && itemData.pendingActionDetails) {
            setCurrentListId(itemData?.pendingActionDetails?.listId);
            setEntityPendingChanges({ revisionId: itemData?.pendingActionDetails?.revisionId });
            toggleSidePanel();
            history.push(clickedBaseRoute + ROUTES.LISTS.PENDING_CHANGES);
            getInvalidateQueries(list || '', subList || '', queryClient);
        }
    };
    const actionDetails = {
        onAction: onActionCallback,
        isActionButtonDisabled: false
    };

    return (
        <SidePanelContentCard
            id={id}
            itemData={itemData}
            expandedCardIndex={expandedCardIndex}
            handleCardHeaderOnClick={handleCardHeaderOnClick}
            actionDetails={actionDetails}
        >
            {isHelperDataAvailable && cardHelperData ? (
                <SidePanelContentCardHelper cardHelperData={cardHelperData} />
            ) : undefined}
        </SidePanelContentCard>
    );
};

export default SidePanelAccordionItemContentCard;
